import { render, staticRenderFns } from "./new_detailsnew.vue?vue&type=template&id=aad4b364&scoped=true&"
import script from "./new_detailsnew.vue?vue&type=script&lang=js&"
export * from "./new_detailsnew.vue?vue&type=script&lang=js&"
import style0 from "./new_detailsnew.vue?vue&type=style&index=0&id=aad4b364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad4b364",
  null
  
)

export default component.exports